import { Container } from 'pixi.js';
import { LoadingSpinnerView } from '../../views/LoadingSpinnerView';
import type { DioramaConfig } from '../../app/state/diorama/dioramaState';
import type { Preload } from '../../app/loader/Preload';
import { DioramaView } from '../../game/views/dioramas/DioramaView';

interface DioramaDisplaySlotConfig {
  dioramaConfig: DioramaConfig;
  progress: number;
  isLocked: boolean;
  preloader: Preload;
}

export class DioramaDisplayOptionView extends Container {
  private initialized = false;

  private readonly loadingSpinner = new LoadingSpinnerView().props({
    parent: this,
  });

  constructor(private readonly config: DioramaDisplaySlotConfig) {
    super();
    this.visible = false;
  }

  public async activate(): Promise<void> {
    if (this.initialized) return;

    this.visible = true;

    this.initialized = true;

    const { dioramaConfig, progress, isLocked, preloader } = this.config;

    await preloader.loadBundles([dioramaConfig.atlas]);

    if (this.destroyed) return;

    new DioramaView({
      config: dioramaConfig,
      progress,
      isLocked,
    }).props({
      parent: this,
    });

    this.loadingSpinner.destroy();
  }

  public isCompleted(): boolean {
    const totalPrice = this.config.dioramaConfig.pieces.reduce((acc, piece) => acc + piece.price, 0);
    return this.config.progress >= totalPrice;
  }
}
